/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Walt custom code created by the shopify AI 4-16-2026
// ADA: Escape key + Tab-out closes open nav submenus (WCAG 2.1 / APG disclosure pattern)
(function () {

  function getOpenItems() {
    return document.querySelectorAll('li.nav-bar__item.is-dropdown-open');
  }

  function closeItem(item) {
    if (window.navInstance && window.navInstance._deactivateDropdown) {
      window.navInstance._deactivateDropdown({}, item);
    }
    // Warehouse's _deactivateDropdown may not complete fully — force cleanup manually
    item.classList.remove('is-dropdown-open');
    const trigger = item.querySelector('[data-type="menuitem"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    const panel = item.querySelector('[aria-hidden]');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    const menu = item.closest('[data-type="menu"]');
    if (menu) menu.classList.remove('nav-dropdown--glued');
  }

  function closeItemAndFocus(item) {
    closeItem(item);
    const trigger = item.querySelector('.nav-bar__link');
    if (trigger) trigger.focus();
  }

  // --- Escape key: close all open submenus, return focus to trigger ---
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    getOpenItems().forEach(closeItemAndFocus);
  });

  // --- Tab-out: snapshot open items, wait for focus to settle ---
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var openItems = Array.from(getOpenItems());
    if (openItems.length === 0) return;

    setTimeout(function () {
      openItems.forEach(function (item) {
        if (!item.contains(document.activeElement)) {
          closeItem(item);
        }
      });
    }, 0);
  });


})();
